import { Card, Col, Form, Input, Row } from 'antd'

import { ProductGroupCategory } from 'src/api/requests'
import { requiredRules } from 'src/app-constants'
import {
  InternationalNamesSelect,
  ProducersSelect,
  StockGroups
} from 'src/components'
import { useLocales } from 'src/locales'

import { MeasurementUnitsSelect } from './MeasurementUnitsSelect'
import { PharmaceuticalFormsSelect } from './PharmaceuticalFormsSelect'

export const ConsumableFields = () => {
  const { t } = useLocales()

  return (
    <Card>
      <Row gutter={[24, 24]}>
        <Col span={24} xl={12}>
          <Form.Item
            name="commercialName"
            rules={requiredRules}
            label={t('medicine_register.products.name')}
          >
            <Input placeholder={t('medicine_register.products.name')} />
          </Form.Item>
        </Col>

        <Col span={24} xl={12}>
          <Form.Item
            name="internationalNameId"
            rules={requiredRules}
            label={t('medicine_register.international_name.title')}
          >
            <InternationalNamesSelect
              placeholder={t('medicine_register.international_name.title')}
            />
          </Form.Item>
        </Col>

        <Col span={24} xl={12}>
          <Form.Item
            name="producerId"
            rules={requiredRules}
            label={t('medicine_register.producers.title')}
          >
            <ProducersSelect
              placeholder={t('medicine_register.producers.title')}
            />
          </Form.Item>
        </Col>

        <Col span={24} xl={12}>
          <Form.Item
            name="measurementUnitId"
            label={t('medicine_register.consumables.measurement_unit')}
            rules={requiredRules}
          >
            <MeasurementUnitsSelect
              placeholder={t('medicine_register.consumables.measurement_unit')}
            />
          </Form.Item>
        </Col>

        <Col span={24} xl={12}>
          <Form.Item
            name="formId"
            rules={requiredRules}
            label={t('medicine_register.pharmaceutical_form.title')}
          >
            <PharmaceuticalFormsSelect
              placeholder={t('medicine_register.pharmaceutical_form.title')}
            />
          </Form.Item>
        </Col>

        <Col span={24} xl={12}>
          <Form.Item
            name="groupId"
            rules={requiredRules}
            label={t('common.group')}
          >
            <StockGroups
              category={ProductGroupCategory.PHARMACEUTICS}
              labelInValue
            />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  )
}
